import { MetricTypes } from '@liquitics/transaction';
import { TrendMetric } from './../trend-metric/trend-metric';
export class ForeignOutflowMetric extends TrendMetric {
    currencies: string[];
    netflow: number;
    netflowShort: string;
    breakDown: {
        'currency': string,
        'fxRate': number,
        'outAmount': number,
        'inAmount': number,
        'baseOutAmount': number,
        'baseInAmount': number,
    }[];

    constructor() {
        super(MetricTypes.FOREIGN_CURRENCY_NETFLOW, 'foreign-outflow');
    }

    reset() {
        this.currencies = [];
        this.breakDown = [];
        this.netflow = 0;
    }
}
